import { observer } from 'mobx-react-lite'
import { FC, useContext, useEffect, useRef, useState } from 'react'
import ImageSlider from '../components/ImageSlider'
import { Context } from '..'

import styles from '../styles/Policy.module.scss'
import useWindowDimensions from '../core/hooks/useWindowDimensions'

const Policy: FC = () => {
	const { store, adminStore } = useContext(Context)
	const { width } = useWindowDimensions()

	useEffect(() => {
		return () => {}
	}, [])

	return (
		<>
			<div className={styles.policy}>
				<div className='container'>
					<div className='row'>
						<div className='col-12'>
							<div className={styles.wrapper}>
								<h1>ПОЛИТИКА ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ</h1>
								{/* <h2>Политика в отношении обработки персональных данных</h2> */}

								<p className={styles.addr}>
									Дата вступления в силу: 29.10.2024
									<br />
									г. Москва редакция от 18.06.2026
								</p>

								<p className={styles.addr}>
									Настоящая Политика обработки персональных данных является неотъемлемой частью Публичной оферты (далее
									– Пользовательское соглашение), размещенной на сайте в сети Интернет по адресу: 
									<a href='https://podcastbery.ru/'>https://podcastbery.ru/</a> (далее – Сайт). Использование сервисов
									Сайта означает безоговорочное согласие Пользователя с настоящей Политикой и указанными в ней условиями
									обработки его персональной информации; в случае несогласия с этими условиями Пользователь должен
									воздержаться от использования сервисов.
									<br />
									<br />
									Настоящая Политика разработана во исполнение требований Федерального закона от 27.07.2006 № 152-ФЗ «О
									персональных данных» (далее — «Закон о персональных данных») и действует в отношении всей информации,
									которую Оператор может получить о Пользователях и Поставщиках при использовании ими Сайта, сервисов и
									услуг Оператора.
								</p>

								<div className={styles.points}>
									<p>
										<b>ОСНОВНЫЕ ПОНЯТИЯ</b>
										<br />
										<b>Автоматизированная обработка персональных данных</b> - обработка персональных данных с помощью
										средств вычислительной техники.
										<br />
										<b>Блокирование персональных данных</b> - временное прекращение обработки персональных данных (за
										исключением случаев, если обработка необходима для уточнения персональных данных).
										<br />
										<b>Заказ</b> - должным образом оформленный запрос Пользователя на получение услуг по бронированию
										Залов, а также дополнительных услуг, выбранных на Сайте.
										<br />
										<b>Обезличивание персональных данных</b> - действия, в результате которых становится невозможным без
										использования дополнительной информации определить принадлежность персональных данных конкретному
										субъекту персональных данных.
										<br />
										<b>Обработка персональных данных</b> любое действие (операция) или совокупность действий (операций)
										с персональными данными, совершаемых с использованием средств автоматизации или без их
										использования. Обработка персональных данных включает в себя в том числе:
										<br />
										- сбор;
										<br />
										- запись;
										<br />
										- систематизацию;
										<br />
										- накопление;
										<br />
										- хранение;
										<br />
										- уточнение (обновление, изменение);
										<br />
										- извлечение;
										<br />
										- использование;
										<br />
										- передачу (распространение, предоставление, доступ);
										<br />
										- обезличивание;
										<br />
										- блокирование;
										<br />
										- удаление;
										<br />
										- уничтожение.
										<br />
										<br />
										<b>Оператор персональных данных (оператор)</b> - ИП Казанцева Виктория Александровна (ИНН 245211492400,
										ОГРИП 326246800097782), самостоятельно или совместно с другими лицами организующее и (или)
										осуществляющее обработку персональных данных, а также определяющее цели обработки персональных
										данных, состав персональных данных, подлежащих обработке, действия (операции), совершаемые с
										персональными данными.
										<br />
										<b>Персональные данные</b> - 1) любая информация, относящаяся к прямо или косвенно определенному или
										определяемому физическому лицу (субъекту персональных данных), которую Пользователь предоставляет о
										себе самостоятельно при регистрации (создании учетной записи) или в процессе использования Сайта,
										включая персональные данные Пользователя. Обязательная для использования Сайта информация помечена
										специальным образом; 2) данные, которые автоматически передаются сервисам Сайта в процессе их
										использования с помощью установленного на устройстве Пользователя программного обеспечения, в том
										числе IP-адрес, данные файлов cookie, информация о браузере Пользователя (или иной программе, с
										помощью которой осуществляется доступ к сервисам), технические характеристики оборудования и
										программного обеспечения, используемых Пользователем, дата и время доступа к сервисам, адреса
										запрашиваемых страниц и иная подобная информация.
										<br />
										<b>Пользователь</b> - дееспособное физическое лицо, достигшее 18 лет, имеющее законное право
										вступать в договорные отношения с Оператором, в том числе размещать заказ или бронировать услуги на
										Сайте.
										<br />
										<b>Предоставление персональных данных</b> - действия, направленные на раскрытие персональных данных
										определенному лицу или определенному кругу лиц.
										<br />
										<b>Распространение персональных данных</b> - действия, направленные на раскрытие персональных данных
										неопределенному кругу лиц.
										<br />
										<b>Сайт</b> - информационный ресурс Оператора в интернете, расположенный по адресу:{' '}
										<a href='https://podcastbery.ru/'>https://podcastbery.ru/</a>.<br />
										<b>Уничтожение персональных данных</b> - действия, в результате которых становится невозможным
										восстановить содержание персональных данных в информационной системе персональных данных и (или) в
										результате которых уничтожаются материальные носители персональных данных.
										<br />
									</p>
									<p>
										<b>СТАТЬЯ 1. ОБЩИЕ ПОЛОЖЕНИЯ</b>
										<br />
										1.1. Настоящая Политика применяется только к Сайту 
										<a href='https://podcastbery.ru/'>https://podcastbery.ru/</a>. Сайт не контролирует и не несет
										ответственности за сайты третьих лиц, на которые Пользователь может перейти по ссылкам, доступным на
										Сайте.
										<br />
										1.2. Во исполнение требований ч. 2 ст. 18.1 Федерального закона «О персональных данных» от
										27.07.2006 № 152-ФЗ настоящая Политика публикуется в свободном доступе в
										информационно-телекоммуникационной сети Интернет на Сайте Оператора.
										<br />
										1.3. Настоящая Политика является общедоступным документом, декларирующим концептуальные основы
										деятельности Оператора при обработке персональных данных. Политика может быть пересмотрена в случае
										изменения законодательства Российской Федерации в области персональных данных, а также в случаях
										изменения договорных отношений с Пользователями и Поставщиками.
										<br />
										1.4. Оператор вправе вносить изменения в настоящую Политику без согласия Пользователя, но с
										обязательным опубликованием новой редакции на Сайте не менее чем за 10 (десять) календарных дней до
										ее вступления в силу, если иное не требуется законом.
									</p>
									<p>
										<b>СТАТЬЯ 2. СОСТАВ ПЕРСОНАЛЬНЫХ ДАННЫХ, КОТОРЫЕ МОГУТ ОБРАБАТЫВАТЬСЯ ОПЕРАТОРОМ</b>
										<br />
										2.1. Оператор может обрабатывать следующие категории персональных данных:
										<br />
										2.1.1. Персональные данные, предоставляемые Пользователем (физическим лицом):
										<br />
										<ul>
											<li>Фамилия, имя, отчество (при наличии);</li>
											<li>Номер контактного телефона;</li>
											<li>Адрес электронной почты (e-mail);</li>
											<li>
												Паспортные данные (серия, номер, кем и когда выдан) — в случае необходимости идентификации
												личности для заключения договоров или оказания отдельных видов услуг;
											</li>
											<li>
												Иные данные, которые Пользователь предоставляет о себе при регистрации (создании учетной записи)
												или в процессе использования Сайта.
											</li>
										</ul>
										2.1.2. Персональные данные, предоставляемые Поставщиком (представителем юридического лица или ИП):
										<br />
										<ul>
											<li>Фамилия, имя, отчество руководителя или уполномоченного представителя;</li>
											<li>Контактный телефон представителя;</li>
											<li>Адрес электронной почты представителя;</li>
											<li>Паспортные данные руководителя или уполномоченного представителя (при необходимости);</li>
											<li>
												ИНН, ОГРН/ОГРИП, банковские реквизиты (содержат персональные данные физического лица — ИП);
											</li>
											<li>Иные данные, необходимые для заключения и исполнения Договора.</li>
										</ul>
										2.1.3. Данные, собираемые автоматически при использовании Сайта:
										<br />
										<ul>
											<li>IP-адрес устройства Пользователя;</li>
											<li>Тип браузера и его настройки;</li>
											<li>Операционная система и ее версия;</li>
											<li>Дата и время доступа к Сайту;</li>
											<li>Адреса запрашиваемых страниц и совершенные действия на Сайте;</li>
											<li>Данные файлов cookie;</li>
											<li>Идентификаторы мобильного устройства (при использовании мобильной версии);</li>
											<li>Информация об аппаратном и программном обеспечении компьютера Пользователя;</li>
											<li>Данные о геолокации (с согласия Пользователя);</li>
											<li>Иная техническая информация.</li>
										</ul>
										2.2. Оператор не осуществляет обработку специальных категорий персональных данных, касающихся
										расовой, национальной принадлежности, политических взглядов, религиозных или философских убеждений,
										состояния здоровья, интимной жизни, за исключением случаев, предусмотренных законодательством
										Российской Федерации и при наличии отдельного письменного согласия субъекта персональных данных.
										<br />
										2.3. Обработка биометрических персональных данных (фотографий, видеозаписей) осуществляется
										Оператором исключительно при наличии отдельного согласия субъекта персональных данных и только в
										целях, для которых такое согласие получено.
										<br />
									</p>
									<p>
										<b>СТАТЬЯ 3. ПРАВОВЫЕ ОСНОВАНИЯ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ</b>
										<br />
										3.1. Обработка персональных данных осуществляется Оператором на следующих правовых основаниях:
										<br />
										3.1.1. Конституция Российской Федерации.
										<br />
										3.1.2. Федеральный закон от 27.07.2006 № 152-ФЗ «О персональных данных».
										<br />
										3.1.3. Гражданский кодекс Российской Федерации.
										<br />
										3.1.4. Федеральный закон от 27.07.2006 № 149-ФЗ «Об информации, информационных технологиях и о
										защите информации».
										<br />
										3.1.5. Иные федеральные законы и нормативные правовые акты Российской Федерации, регулирующие
										отношения, связанные с деятельностью Оператора.
										<br />
										3.1.6. Согласия субъектов персональных данных на обработку их персональных данных.
										<br />
										3.1.7. Договоры, заключаемые между Оператором и субъектами персональных данных (Пользовательское
										соглашение, Партнерское соглашение, иные договоры и соглашения).
										<br />
										3.2. В соответствии с ч. 1 ст. 6 Закона о персональных данных обработка персональных данных
										осуществляется с согласия субъекта персональных данных, за исключением случаев, предусмотренных
										законодательством.
										<br />
										3.3. В соответствии с п. 5 ч. 1 ст. 6 Закона о персональных данных обработка персональных данных
										допускается без согласия субъекта персональных данных, если она необходима для исполнения договора,
										стороной которого либо выгодоприобретателем или поручителем по которому является субъект
										персональных данных.
									</p>
									<p>
										<b>СТАТЬЯ 4. ПОРЯДОК И УСЛОВИЯ ПОЛУЧЕНИЯ СОГЛАСИЯ НА ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ</b>
										<br />
										4.1. Согласие на обработку персональных данных оформляется Оператором отдельно от иных документов,
										которые подписывает или подтверждает субъект персональных данных, в соответствии с требованиями ст.
										9 Закона о персональных данных и с учетом изменений, вступивших в силу с 01.09.2025.
										<br />
										4.2. Нажатие кнопки «Перейти к оплате», «Забронировать», «Зарегистрироваться», отметка пункта «Я даю
										согласие на обработку моих персональных данных» или иное аналогичное действие при размещении Заказа
										на Сайте означает предоставление Пользователем отдельного, конкретного, информированного,
										сознательного и однозначного согласия на обработку персональных данных в соответствии с текстом
										такого согласия, предлагаемого Оператором в момент совершения действия.
										<br />
										4.3. Согласие на обработку персональных данных, разрешенных для распространения, оформляется
										отдельно от иных согласий и содержит:
										<ul>
											<li>перечень персональных данных, разрешенных для распространения;</li>
											<li>условия и запреты на обработку неограниченным кругом лиц;</li>
											<li>срок действия согласия;</li>
											<li>иные сведения, предусмотренные ст. 10.1 Закона о персональных данных.</li>
										</ul>
										4.4. Оператор обязан в срок не позднее трех рабочих дней с момента получения согласия на обработку
										персональных данных, разрешенных для распространения, опубликовать информацию об условиях обработки,
										о наличии запретов и условий на обработку неограниченным кругом лиц таких персональных данных.
									</p>
									<p>
										<b>СТАТЬЯ 5. ЦЕЛИ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ</b>
										<br />
										5.1. Оператор осуществляет обработку персональных данных в следующих целях:
										<table>
											<tr>
												<td>
													<strong>Цель обработки</strong>
												</td>
												<td>
													<strong>Категории обрабатываемых данных</strong>
												</td>
											</tr>
											<tr>
												<td>Идентификация Пользователя/Поставщика при регистрации и использовании Сайта</td>
												<td>ФИО, телефон, email, паспортные данные (при необходимости)</td>
											</tr>
											<tr>
												<td>Заключение и исполнение договоров (Пользовательского и Партнерского соглашений)</td>
												<td>ФИО, телефон, email, паспортные данные, ИНН, ОГРН/ОГРИП, банковские реквизиты</td>
											</tr>
											<tr>
												<td>Предоставление доступа к персонализированным ресурсам Сайта</td>
												<td>Логин, пароль, email</td>
											</tr>
											<tr>
												<td>Обработка и исполнение Заказов, бронирований</td>
												<td>ФИО, телефон, email</td>
											</tr>
											<tr>
												<td>Осуществление расчетов, перечисление денежных средств</td>
												<td>ФИО, банковские реквизиты, ИНН</td>
											</tr>
											<tr>
												<td>Связь с Пользователем/Поставщиком, направление уведомлений</td>
												<td>Телефон, email</td>
											</tr>
											<tr>
												<td>Улучшение качества услуг, анализ пользовательского опыта</td>
												<td>Данные cookie, IP-адрес, техническая информация</td>
											</tr>
											<tr>
												<td>Направление информационных и рекламных сообщений (рассылок)</td>
												<td>Email, телефон (при наличии отдельного согласия)</td>
											</tr>
											<tr>
												<td>Обеспечение безопасности и предотвращение мошенничества</td>
												<td>IP-адрес, данные cookie, техническая информация</td>
											</tr>
											<tr>
												<td>Исполнение требований законодательства РФ</td>
												<td>Все необходимые категории данных</td>
											</tr>
										</table>
										<br />
										5.2. Обработка персональных данных ограничивается достижением конкретных, заранее определенных и
										законных целей. Не допускается обработка персональных данных, несовместимая с целями сбора
										персональных данных.
									</p>
									<p>
										<b>СТАТЬЯ 6. СРОКИ ОБРАБОТКИ И ХРАНЕНИЯ ПЕРСОНАЛЬНЫХ ДАННЫХ</b>
										<br />
										6.1. Персональные данные обрабатываются Оператором в сроки, необходимые для достижения целей
										обработки, если иные сроки не установлены договором или законодательством Российской Федерации.
										<br />
										6.2. Конкретные сроки обработки и хранения персональных данных определяются в зависимости от цели
										обработки:
										<table>
											<tr>
												<td>
													<strong>Цель обработки</strong>
												</td>
												<td>
													<strong>Срок хранения</strong>
												</td>
											</tr>
											<tr>
												<td>Исполнение договора с Пользователем/Поставщиком</td>
												<td>
													В течение срока действия договора и 3 (трех) лет с момента окончания его действия или
													последнего взаимодействия с субъектом
												</td>
											</tr>
											<tr>
												<td>Ведение бухгалтерского и налогового учета</td>
												<td>5 (пять) лет с момента окончания отчетного года</td>
											</tr>
											<tr>
												<td>Хранение документов по личному составу (для сотрудников)</td>
												<td>
													В соответствии с Перечнем типовых управленческих архивных документов (от 20.12.2019 № 236)
												</td>
											</tr>
											<tr>
												<td>Обработка обращений и запросов</td>
												<td>3 (три) года с момента последнего обращения</td>
											</tr>
											<tr>
												<td>Маркетинговые рассылки</td>
												<td>До момента отзыва согласия на получение рассылки</td>
											</tr>
											<tr>
												<td>Аналитические данные (обезличенные)</td>
												<td>Неограниченный срок</td>
											</tr>
											<tr>
												<td>Данные cookie (постоянные)</td>
												<td>
													В соответствии со сроком действия конкретного cookie-файла (от нескольких минут до нескольких
													лет)
												</td>
											</tr>
										</table>
										<br />
										6.3. Хранение персональных данных осуществляется в форме, позволяющей определить субъекта
										персональных данных, не дольше, чем этого требуют цели обработки персональных данных, если срок
										хранения персональных данных не установлен федеральным законом или договором, стороной которого
										является субъект персональных данных.
									</p>
									<p>
										<b>СТАТЬЯ 7. УНИЧТОЖЕНИЕ ПЕРСОНАЛЬНЫХ ДАННЫХ</b>
										<br />
										7.1. Обрабатываемые персональные данные подлежат уничтожению либо обезличиванию по достижении целей
										обработки или в случае утраты необходимости в достижении этих целей, если иное не предусмотрено
										действующим законодательством.
										<br />
										7.2. В случае достижения цели обработки персональных данных Оператор обязан прекратить обработку
										персональных данных и уничтожить их в срок, не превышающий 30 (тридцати) дней с даты достижения цели
										обработки, если иное не предусмотрено договором или федеральным законом.
										<br />
										7.3. Уничтожение персональных данных осуществляется комиссией, создаваемой Оператором, с оформлением
										Акта об уничтожении персональных данных. Способ уничтожения должен исключать возможность дальнейшего
										восстановления персональных данных.
										<br />
										7.4. В случае отсутствия возможности уничтожения персональных данных в течение указанного срока
										Оператор осуществляет блокирование таких персональных данных и обеспечивает их уничтожение в срок не
										более 6 (шести) месяцев, если иное не установлено федеральным законом.
										<br />
										7.5. По требованию субъекта персональных данных или уполномоченного органа по защите прав субъектов
										персональных данных Оператор обязан подтвердить уничтожение персональных данных в порядке,
										установленном Приказом Роскомнадзора от 28.10.2022 № 179.
									</p>
									<p>
										<b>СТАТЬЯ 8. ПРАВА СУБЪЕКТОВ ПЕРСОНАЛЬНЫХ ДАННЫХ</b>
										<br />
										8.1. Субъект персональных данных (Пользователь или Поставщик — физическое лицо) имеет следующие
										права:
										<br />
										8.1.1. Право на доступ к своим персональным данным. Субъект вправе получать от Оператора информацию,
										касающуюся обработки его персональных данных, включая:
										<ul>
											<li>подтверждение факта обработки персональных данных;</li>
											<li>правовые основания и цели обработки;</li>
											<li>применяемые способы обработки;</li>
											<li>наименование и место нахождения Оператора;</li>
											<li>сведения о лицах, которые имеют доступ к персональным данным;</li>
											<li>перечень обрабатываемых персональных данных и источник их получения;</li>
											<li>сроки обработки и хранения персональных данных;</li>
											<li>порядок осуществления прав субъекта персональных данных.</li>
										</ul>
										8.1.2. Право на уточнение (изменение) персональных данных. Субъект вправе требовать от Оператора
										уточнения его персональных данных в случае, если они являются неполными, устаревшими или неточными.
										<br />
										8.1.3. Право на отзыв согласия на обработку персональных данных. Субъект вправе в любое время
										отозвать согласие на обработку персональных данных, направив Оператору соответствующее заявление.
										<br />
										8.1.4. Право на удаление (уничтожение) персональных данных. Субъект вправе требовать уничтожения
										своих персональных данных в случаях, если:
										<ul>
											<li>
												персональные данные являются незаконно полученными или не являются необходимыми для заявленной
												цели обработки;
											</li>
											<li>
												отозвано согласие на обработку персональных данных и отсутствуют иные правовые основания для
												обработки;
											</li>
											<li>достигнуты цели обработки персональных данных.</li>
										</ul>
										8.1.5. Право на блокирование персональных данных. Субъект вправе требовать блокирования своих
										персональных данных на период проверки в случае выявления недостоверных персональных данных или
										неправомерных действий.
										<br />
										8.1.6. Право на обжалование действий или бездействия Оператора. Субъект вправе обжаловать действия
										или бездействие Оператора в уполномоченный орган по защите прав субъектов персональных данных
										(Роскомнадзор) или в судебном порядке.
										<br />
										8.1.7. Право на защиту своих прав и законных интересов. Субъект имеет право на защиту своих прав и
										законных интересов, в том числе на возмещение убытков и (или) компенсацию морального вреда в
										судебном порядке.
									</p>
									<p>
										<b>СТАТЬЯ 9. ПОРЯДОК РЕАЛИЗАЦИИ ПРАВ СУБЪЕКТОВ ПЕРСОНАЛЬНЫХ ДАННЫХ</b>
										<br />
										9.1. Для реализации своих прав субъект персональных данных направляет Оператору соответствующее
										заявление (требование, запрос) одним из следующих способов:
										<ul>
											<li>
												По электронной почте: <a href='mailto:info@podcastbery.ru'>info@podcastbery.ru</a> (с
												обязательным направлением скан-копии заявления, подписанного собственноручной или электронной
												подписью);
											</li>
											<li>
												Почтовым отправлением: по юридическому адресу Оператора (заказным письмом с уведомлением о
												вручении);
											</li>
											<li>Через форму обратной связи: в Личном кабинете на Сайте.</li>
										</ul>
										9.2. Заявление должно содержать:
										<ul>
											<li>Фамилию, имя, отчество субъекта персональных данных;</li>
											<li>
												Контактную информацию (номер телефона, адрес электронной почты или почтовый адрес), по которой
												должен быть направлен ответ;
											</li>
											<li>
												Сведения, подтверждающие участие субъекта в отношениях с Оператором (номер договора, дата
												регистрации, номер телефона, использованный при регистрации, и т.п.) либо иные сведения,
												позволяющие идентифицировать субъекта;
											</li>
											<li>Суть требования (запроса);</li>
											<li>
												Перечень персональных данных, к которым запрашивается доступ, или которые подлежат уточнению,
												удалению, блокированию;
											</li>
											<li>Дату и подпись заявителя.</li>
										</ul>
										9.3. В случае направления заявления представителем субъекта персональных данных к заявлению
										прилагается доверенность или иной документ, подтверждающий полномочия представителя.
										<br />
										9.4. Оператор рассматривает заявление и направляет ответ заявителю в срок, не превышающий 7 (семи)
										рабочих дней с даты поступления заявления, если иной срок не предусмотрен законодательством.
										<br />
										9.5. В предоставлении информации может быть отказано в случаях, предусмотренных ч. 8 ст. 14 Закона о
										персональных данных (например, если запрашиваемая информация касается персональных данных других лиц
										или если доступ нарушает права и законные интересы третьих лиц).
										<br />
										9.6. При отзыве субъектом согласия на обработку персональных данных Оператор вправе продолжить
										обработку без согласия при наличии оснований, указанных в п. 2-11 ч. 1 ст. 6, ч. 2 ст. 10 и ч. 2 ст.
										11 Закона о персональных данных.  
									</p>
									<p>
										<b>СТАТЬЯ 10. ОБЯЗАННОСТИ ОПЕРАТОРА</b>
										<br />
										10.1. Оператор обязан:
										<br />
										10.1.1. Предоставлять субъекту персональных данных по его запросу информацию, касающуюся обработки
										его персональных данных, в порядке, установленном настоящей Политикой.
										<br />
										10.1.2. Организовывать обработку персональных данных в порядке, установленном действующим
										законодательством РФ.
										<br />
										10.1.3. Отвечать на обращения и запросы субъектов персональных данных в установленные сроки.
										<br />
										10.1.4. Сообщать в уполномоченный орган по защите прав субъектов персональных данных (Роскомнадзор)
										по его запросу необходимую информацию в течение 30 (тридцати) дней с даты получения такого запроса.
										<br />
										10.1.5. Опубликовывать и обеспечивать неограниченный доступ к настоящей Политике.
										<br />
										10.1.6. Принимать правовые, организационные и технические меры для защиты персональных данных от
										неправомерного или случайного доступа, уничтожения, изменения, блокирования, копирования,
										предоставления, распространения, а также от иных неправомерных действий.
										<br />
										10.1.7. Прекратить передачу (распространение, предоставление, доступ) персональных данных,
										прекратить обработку и уничтожить персональные данные в порядке и случаях, предусмотренных Законом о
										персональных данных.
										<br />
										10.1.8. Осуществить блокирование персональных данных с момента обращения или запроса субъекта на
										период проверки в случае выявления недостоверных персональных данных или неправомерных действий.
										<br />
										10.1.9. При утрате или разглашении персональных данных информировать субъекта об утрате или
										разглашении.
										<br />
										10.1.10. Исполнять иные обязанности, предусмотренные Законом о персональных данных.
									</p>
									<p>
										<b>СТАТЬЯ 11. ОБЯЗАННОСТИ СУБЪЕКТОВ ПЕРСОНАЛЬНЫХ ДАННЫХ</b>
										<br />
										11.1. Субъекты персональных данных обязаны:
										<br />
										11.1.1. Предоставлять Оператору достоверные данные о себе в объеме, необходимом для достижения целей
										обработки.
										<br />
										11.1.2. Сообщать Оператору об уточнении (обновлении, изменении) своих персональных данных.
										<br />
										11.1.3. Оформлять согласие на обработку персональных данных в порядке, предусмотренном настоящей
										Политикой и законодательством РФ.
										<br />
										11.1.4. Не сообщать третьим лицам логин и пароль для доступа к Личному кабинету. В случае подозрения
										относительно безопасности логина и пароля или возможности их несанкционированного использования
										третьими лицами незамедлительно уведомить об этом Оператора.
										<br />
										11.2. Субъекты, передавшие Оператору недостоверные сведения о себе либо сведения о другом субъекте
										персональных данных без согласия последнего, несут ответственность в соответствии с
										законодательством РФ.
									</p>
									<p>
										<b>СТАТЬЯ 12. ПЕРЕДАЧА ПЕРСОНАЛЬНЫХ ДАННЫХ ТРЕТЬИМ ЛИЦАМ</b>
										<br />
										12.1. Оператор вправе передавать персональные данные субъектов третьим лицам в следующих случаях:
										<br />
										12.1.1. Субъект выразил согласие на такие действия.
										<br />
										12.1.2. Передача необходима для использования субъектом определенного сервиса либо для исполнения
										договора с субъектом.
										<br />
										12.1.3. Передача предусмотрена российским или иным применимым законодательством в рамках
										установленной процедуры.
										<br />
										12.2. Размещая на Сайте Заказ и предоставляя согласие, Пользователь дает согласие Оператору на
										передачу своих персональных данных Поставщикам услуг (студиям), а также третьим лицам, действующим
										на основании договора с Оператором (платежные системы, службы доставки, партнеры по маркетингу), для
										исполнения обязательств перед Пользователем в соответствии с заключенным договором.
										<br />
										12.3. К таким третьим лицам относятся:
										<ul>
											<li>Поставщики услуг (студии звукозаписи, арендодатели залов);</li>
											<li>Платежные системы (ЮMoney и др.);</li>
											<li>Партнеры по организации мероприятий и акций;</li>
											<li>Иные лица, привлеченные Оператором для оказания услуг субъекту.</li>
										</ul>
										12.4. Трансграничная передача персональных данных на территорию иностранных государств, не
										обеспечивающих адекватной защиты прав субъектов персональных данных, осуществляется Оператором
										только при наличии согласия субъекта в письменной форме.
									</p>
									<p>
										<b>СТАТЬЯ 13. ИСПОЛЬЗОВАНИЕ ФАЙЛОВ COOKIE И АНАЛОГИЧНЫХ ТЕХНОЛОГИЙ</b>
										<br />
										13.1. Общие положения о cookie-файлах. При использовании Пользователем Сайта Оператор может
										осуществлять сбор и обработку информации с помощью файлов cookie (куки) и аналогичных технологий,
										включая веб-маяки, пиксельные теги, локальное хранилище, идентификаторы мобильных устройств и иные
										средства автоматического сбора данных.
										<br />
										13.2. Типы используемых cookie-файлов и цели их применения. В зависимости от назначения и
										выполняемых функций Оператор использует следующие категории файлов cookie:
										<br />
										Строго необходимые (технические) cookie. Данные файлы обеспечивают корректное функционирование
										Сайта, позволяют Пользователю перемещаться по Сайту и использовать его основные функции, включая
										навигацию, доступ к защищенным разделам, процесс оформления Заказа и аутентификацию в Личном
										кабинете. Без использования этих файлов работа Сайта может быть невозможна или существенно
										затруднена. Функциональные cookie. Данные файлы позволяют запоминать выборы и предпочтения
										Пользователя для улучшения удобства использования Сайта и предоставления персонализированных
										функций. К таким предпочтениям могут относиться выбранный язык интерфейса, регион, сохраненные
										параметры фильтрации Залов, история просмотров и иные настройки. Аналитические (статистические)
										cookie. Данные файлы собирают обезличенную информацию о том, как Пользователи взаимодействуют с
										Сайтом: какие страницы посещают, сколько времени проводят на Сайте, с каких устройств и браузеров
										заходят, фиксируют ошибки при использовании. Полученные данные используются исключительно в
										агрегированном и обезличенном виде для анализа и улучшения производительности Сайта. Для сбора
										статистики Оператор может использовать сервисы Яндекс.Метрика и др. Рекламные (маркетинговые)
										cookie. Данные файлы используются для отслеживания активности Пользователя на Сайте с целью
										последующего показа релевантной рекламы на сторонних интернет-ресурсах, ограничения количества
										показов одного и того же рекламного объявления, измерения эффективности проводимых рекламных
										кампаний. Такие cookie могут устанавливаться как самим Оператором, так и его рекламными партнерами.
										<br />
										13.3. Срок хранения cookie-файлов. В зависимости от срока хранения на устройстве Пользователя cookie
										подразделяются на два типа:
										<ul>
											<li>
												Сессионные cookie — существуют только в течение одной сессии работы с браузером и удаляются
												автоматически после закрытия браузера.
											</li>
											<li>
												Постоянные (persistent) cookie — сохраняются на устройстве Пользователя после завершения сеанса
												работы до истечения установленного срока их действия либо до момента их ручного удаления
												Пользователем.
											</li>
										</ul>
										13.4. Правовые основания обработки и получение согласия. При первом посещении Сайта Пользователю
										отображается специальное уведомление (информационный баннер) об использовании файлов cookie с
										предложением ознакомиться с настоящей Политикой и настроить параметры cookie. Продолжая использовать
										Сайт после ознакомления с указанным уведомлением, Пользователь считается выразившим согласие на
										использование строго необходимых и функциональных cookie-файлов. Согласие на использование
										аналитических и рекламных cookie-файлов запрашивается отдельно и явно через интерфейс настроек.
										<br />
										13.5. Управление cookie и порядок отказа от их использования. Пользователь может в любой момент
										изменить настройки использования cookie, а также отозвать ранее данное согласие одним из следующих
										способов:
										<ul>
											<li>
												Через интерфейс Сайта — в специальном разделе настроек cookie, доступном по ссылке в футере
												Сайта или в Личном кабинете.
											</li>
											<li>
												Через настройки браузера — Пользователь может самостоятельно управлять cookie-файлами, используя
												соответствующие настройки своего веб-браузера (раздел «Справка» или «Настройки» конкретного
												браузера).
											</li>
											<li>
												Через обращение к Оператору — путем направления запроса на адрес электронной почты 
												<a href='mailto:info@podcastbery.ru'>info@podcastbery.ru</a>.
											</li>
										</ul>
										13.6. Последствия отказа от cookie. Отказ от использования строго необходимых cookie-файлов может
										привести к невозможности корректной работы Сайта, включая оформление Заказов и доступ к Личному
										кабинету. Отказ от использования функциональных, аналитических и рекламных cookie не препятствует
										базовому функционированию Сайта, однако может привести к тому, что отдельные функции станут
										недоступны, а реклама и контент — менее релевантными интересам Пользователя.
										<br />
										13.7. Cookie третьих лиц. На Сайте могут использоваться cookie-файлы, устанавливаемые доверенными
										партнерами Оператора, включая сервисы веб-аналитики (Яндекс.Метрика и др.), платежные системы
										(ЮMoney), рекламные сети и иные сторонние сервисы. Оператор не контролирует такие cookie и не
										управляет ими самостоятельно. Политика обработки данных такими третьими лицами регулируется их
										собственными документами.
									</p>
									<p>
										<b>СТАТЬЯ 14. НАПРАВЛЕНИЕ ИНФОРМАЦИОННЫХ И РЕКЛАМНЫХ СООБЩЕНИЙ</b>
										<br />
										14.1. Отдельной целью обработки предоставленных Пользователем контактных данных (адреса электронной
										почты, номера телефона) является направление ему информационных, новостных и рекламных сообщений
										(рассылок) от имени Оператора и/или его партнеров. Рассылка может включать информацию о новостях,
										обновлениях и новых возможностях Сайта, специальных предложениях, акциях, скидках, мероприятиях
										Оператора и его партнеров.
										<br />
										14.2. Согласие на получение рекламных рассылок предоставляется Пользователем отдельно и явно, путем
										проставления соответствующей отметки в специально предназначенном для этого поле интерфейса Сайта
										при регистрации, оформлении Заказа или подписке на новости.
										<br />
										14.3. Согласие на рассылку предоставляется на срок действия учетной записи Пользователя либо до
										момента отзыва такого согласия.
										<br />
										14.4. Пользователь вправе в любой момент отказаться от получения рекламных рассылок, отозвав свое
										согласие, одним из следующих способов:
										<ul>
											<li>
												путем использования ссылки для отписки («unsubscribe»), которая содержится в тексте каждого
												рекламного электронного письма;
											</li>
											<li>
												путем направления соответствующего заявления на электронную почту Оператора: 
												<a href='mailto:info@podcastbery.ru'>info@podcastbery.ru</a>.
											</li>
										</ul>
										14.5. Оператор обязуется прекратить направление рекламных сообщений в течение 3 (трех) рабочих
										дней с момента получения отзыва согласия или запроса на отписку.
										<br />
										14.6. Отзыв согласия на рекламные рассылки не влечет автоматического удаления учетной записи
										Пользователя или прекращения обработки его персональных данных в иных целях, предусмотренных
										настоящей Политикой (например, для исполнения договора бронирования).
									</p>
									<p>
										<b>СТАТЬЯ 15. МЕРЫ ПО ЗАЩИТЕ ПЕРСОНАЛЬНЫХ ДАННЫХ</b>
										<br />
										15.1. Оператор принимает необходимые правовые, организационные и технические меры для защиты
										персональной информации Пользователя от неправомерного или случайного доступа, уничтожения,
										изменения, блокирования, копирования, распространения, а также от иных неправомерных действий
										третьих лиц.
										<br />
										15.2. К таким мерам относятся:
										<ul>
											<li>назначение лица, ответственного за организацию обработки персональных данных;</li>
											<li>издание локальных актов по вопросам обработки персональных данных;</li>
											<li>
												применение правовых, организационных и технических мер обеспечения безопасности персональных
												данных;
											</li>
											<li>
												осуществление внутреннего контроля соответствия обработки персональных данных требованиям
												законодательства;
											</li>
											<li>оценка вреда, который может быть причинен субъектам персональных данных;</li>
											<li>ознакомление работников Оператора с положениями законодательства о персональных данных;</li>
											<li>ограничение состава лиц, имеющих доступ к персональным данным;</li>
											<li>применение средств защиты информации, прошедших процедуру оценки соответствия.</li>
										</ul>
										15.3. При обработке персональных данных в информационных системах Оператор обеспечивает:
										<ul>
											<li>
												проведение мероприятий, направленных на предотвращение несанкционированного доступа к
												персональным данным;
											</li>
											<li>своевременное обнаружение фактов несанкционированного доступа;</li>
											<li>недопущение воздействия на технические средства обработки персональных данных;</li>
											<li>регистрацию и учет действий с персональными данными;</li>
											<li>контроль принимаемых мер по обеспечению безопасности персональных данных.</li>
										</ul>
										15.4. Оператор совместно с Пользователем принимает все необходимые меры по предотвращению убытков
										или иных отрицательных последствий, вызванных утратой или разглашением персональных данных
										Пользователя.
									</p>
									<p>
										<b>СТАТЬЯ 16. ОТВЕТСТВЕННОСТЬ СТОРОН</b>
										<br />
										16.1. Оператор, не исполнивший свои обязательства, несёт ответственность за убытки, понесённые
										Пользователем в связи с неправомерным использованием персональных данных, в соответствии с
										законодательством Российской Федерации, в том числе в размерах, установленных Кодексом Российской
										Федерации об административных правонарушениях. <br />
										16.2. В случае утраты или разглашения конфиденциальной информации Оператор не несёт ответственности,
										если данная информация:
										<ul>
											<li>стала публичным достоянием до её утраты или разглашения;</li>
											<li>была получена от третьей стороны до момента её получения Оператором;</li>
											<li>была разглашена с согласия Пользователя;</li>
											<li>была разглашена на Сайте самим Пользователем.</li>
										</ul>
										16.3. Оператор не несёт ответственности за сведения, предоставленные Пользователем на Сайте в
										общедоступной форме.
										<br />
										16.4. Лица, виновные в нарушении норм, регулирующих получение, обработку и защиту персональных
										данных, несут дисциплинарную, административную, гражданско-правовую или уголовную ответственность в
										соответствии с законодательством Российской Федерации.
									</p>
									<p>
										<b>СТАТЬЯ 17. ПОРЯДОК РАЗРЕШЕНИЯ СПОРОВ</b>
										<br />
										17.1. До обращения в суд с иском по спорам, возникающим из отношений между Пользователем Сайта и
										Оператором, обязательным является предъявление претензии (письменного предложения о добровольном
										урегулировании спора).
										<br />
										17.2. Получатель претензии в течение 10 (десяти) рабочих дней со дня получения претензии письменно
										уведомляет заявителя претензии о результатах рассмотрения претензии.
										<br />
										17.3. При недостижении соглашения спор будет передан на рассмотрение в суд в соответствии с
										действующим законодательством Российской Федерации по месту нахождения Оператора.
										<br />
										17.4. К настоящей Политике обработки персональных данных и отношениям между Пользователем и
										Оператором применяется действующее законодательство Российской Федерации.
									</p>
									<p>
										<b>СТАТЬЯ 18. ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ</b>
										<br />
										18.1. Настоящая Политика является неотъемлемой частью Пользовательского соглашения и Партнерского
										соглашения, размещенных на Сайте в сети Интернет по адресу: 
										<a href='https://podcastbery.ru/'>https://podcastbery.ru/</a>.
										<br />
										18.2. Все предложения или вопросы по настоящей Политике обработки персональных данных следует
										направлять Оператору по электронной почте 
										<a href='mailto:info@podcastbery.ru'>info@podcastbery.ru</a>.
										<br />
										18.3. Признание судом недействительности какого-либо положения настоящей Политики не влечёт за собой
										недействительность остальных положений.
									</p>
									<p>
										<b>РЕКВИЗИТЫ ОПЕРАТОРА:</b>
										<br />
										ИП КАЗАНЦЕВА ВИКТОРИЯ АЛЕКСАНДРОВНА
										<br />
										ИНН 245211492400, ОГРИП 326246800097782
										<br />
										<a href='mailto:info@podcastbery.ru'>info@podcastbery.ru</a>
										<br />
										<a href='tel:+79831402030'>+7 (983) 140-20-30</a>
										<br /> Сайт: <a href='https://podcastbery.ru/'>https://podcastbery.ru/</a>
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

export default observer(Policy)
